import { IApi } from '@/setup/api-client'
import { useApiQuery } from '@/utils/api/api-query'
import { useApiToolbox } from '@/utils/api/use-api-toolbox'
import type { AdTrendDataResponse } from 'api/dist/routes/organization/[organization_id]/brands/[brand_slug]/research/ads/[ad_uuid]/trend-data'

export type IAdTrendData = AdTrendDataResponse

export interface IGetAdTrendDataParams {
    organizationId: string
    brandSlug: string
    adUuid: string
}

export class GetAdTrendDataQuery {
    static getKey(params: IGetAdTrendDataParams) {
        return ['ad-trend-data', params.organizationId, params.brandSlug, params.adUuid]
    }

    static call(api: IApi, params: IGetAdTrendDataParams) {
        return api
            .get<IAdTrendData>(
                `/organization/${params.organizationId}/brands/${params.brandSlug}/research/ads/${params.adUuid}/trend-data`
            )
            .then((res) => res?.data)
    }
}

export const useGetAdTrendDataQuery = (adUuid: string, enabled: boolean) => {
    const { api, apiParams } = useApiToolbox()

    const params: IGetAdTrendDataParams = {
        organizationId: apiParams.organizationId,
        brandSlug: apiParams.brandSlug,
        adUuid,
    }

    return useApiQuery({
        queryKey: GetAdTrendDataQuery.getKey(params),
        queryFn: () => GetAdTrendDataQuery.call(api, params),
        enabled: enabled && !!apiParams.organizationId && !!adUuid,
        // No explicit staleTime — fall back to the app default; ad trend data changes slowly.
    })
}
